<template>
  <div class="user-self-score-content" @click="goToNext(userInfo.contract_id)">
    <!--    用户信息    -->
    <div class="box-user">
      <img
        class="head-image"
        :src="userInfo.user_info.imageUrl ? userInfo.user_info.imageUrl : require('@/assets/images/service/man.png')"
        alt=""
        v-if="userInfo.user_info.gender===1"
      />
       <img
        class="head-image"
        v-else
        :src="userInfo.user_info.imageUrl ? userInfo.user_info.imageUrl : require('@/assets/images/service/woman.png')"
        alt=""
      />

      <div class="box-user-cen">
        <div class="user-top">
          <div class="name">{{ userInfo.user_info.user_name }}</div>
          <div class="project-name">{{ userInfo.user_info.project_name }}</div>
        </div>
        <div class="address">{{ userInfo.user_info.useraddress }}</div>

      </div>

      <!--      得分      -->
      <div class="box-user-right" :class="{ 'box-user-right-red': userInfo.user_info.score <= 50 }">
        <!-- <p class="score">{{ userInfo.user_info.score }}</p> -->
        <p class="score">{{ userInfo.service.score }}</p>
        <p class="title">项目综合分</p>
      </div>
    </div>
    <!--   时间信息   -->
    <div class="box-time">
      <p>开工时间：{{ userInfo.user_info.start_date }}</p>
      <p>完工时间：{{ userInfo.user_info.finish_date }}</p>
    </div>

    <div class="contract-no">合同号：{{ userInfo.user_info.contract_code }}</div>
  </div>
</template>

<script>
export default {
  name: "userSelfScore",
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    //   跳转详情,传入合同id
    goToNext(id) {
      // console.log(id);
      this.$router.push({ path: "/service/scoredetail/index", query: { id: id } });
    },
  },
};
</script>

<style scoped lang="scss">
.user-self-score-content {
  background: #ffffff;
  border-radius: $commonRadius;
  padding: 24px 18px 28px;
  font-size: $smallSize;

  .box-user {
    padding-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f5f5f5;
    margin-bottom: 22px;

    .head-image {
      flex: 0;
      width: 84px;
      height: 84px;
    //   margin-right: 20px;
      margin-right: 10px;
      border-radius: 100%;
    }

    .box-user-cen {
      flex: 1;
      padding-right: 5px;

      .user-top {
        display: flex;
        align-items: center;

        margin-bottom: 6px;

        .name {
        //   font-size: $bigSize;
        font-size: 25px;
          color: #6c9276;
          line-height: 44px;
          font-weight: 500;
          white-space: nowrap;
        }

        .icon {
          width: 92px;
          height: 40px;
          margin: 0 12px;
        }
        .project-name {
          height: 36px;
          background: #318544;
          border-radius: 4px 16px 4px 16px;
          text-align: center;
          line-height: 36px;
          color: #ffffff;
          font-size: 24px;
          padding: 2px 8px;
          margin-left: 15px;
          box-sizing: border-box;
        }
      }

      .address {
        line-height: 34px;
        color: #a2a2a2;
      }
    }

    .box-user-right {
      flex: 0 0 120px;
      text-align: center;
      height: 100px;
      position: relative;
      display: flex;
      justify-content: center;
      color: $deepGreen;

      .score {
        // font-size: 52px;
        font-size: 50px;
        line-height: 84px;
        font-weight: 500;
      }

      .title {
        width: 100%;
        position: absolute;
        bottom: 0;
      }
    }

    .box-user-right-red {
      color: #eb6f56;
    }
  }

  .box-time {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $baseSize;
    color: $commonText;
    margin-bottom: 20px;

    p {
      line-height: 40px;
    }
  }

  .contract-no {
    color: #a2a2a2;
    line-height: 34px;
  }
}
</style>
